

























































import { Component, Vue, Watch } from 'vue-property-decorator';
import { MessageController } from '@/services/request.service';
import { MessageResponse } from '@/services/__model';
import moment from 'moment';

@Component
export default class MessageList extends Vue {
  public data: Array<MessageResponse> = [];
  public moment = moment;
  public columnsData: any = [
    {
      dataIndex: 'redDot',
      key: 'redDot',
      align: 'right',
      scopedSlots: { customRender: 'redDot' },
    },
    // {
    //   dataIndex: 'type',
    //   key: 'type',
    //   align: 'left',
    //   scopedSlots: { customRender: 'type' },
    // },
    {
      dataIndex: 'title',
      key: 'title',
      align: 'left',
      scopedSlots: { customRender: 'msg-title' },
    },
    {
      dataIndex: 'content',
      key: 'content',
      align: 'left',
      scopedSlots: { customRender: 'content' },
    },
    {
      dataIndex: 'toMember',
      key: 'toMember',
      align: 'left',
      scopedSlots: { customRender: 'toMember' },
    },
  ];

  public created(): void {
    this.getList();
  }

  public getList(): void {
    MessageController.getLatestReceiveMessageList(5).then(res => {
      this.data = res.data ? res.data : [];
      const total: number = this.data.length;
      this.$store.commit('setNewMessageNum', total);
    });
  }

  public jumpToDetail(record: any): void {
    const id = record.messageId;
    const studentId = record.toMemberId;
    if (studentId && id) {
      MessageController.updateReadFlag(id)
        .then(res => {
          this.$router.push({ name: 'receiveMsgDetail', query: { id, studentId } });
        })
        .catch(() => {});
    }
  }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get columns(): any {
    return this.columnsData.map((item: any) => {
      if (item.dataIndex !== 'redDot') {
        return {
          ...item,
          title: this.$t(`messageTable.${item.dataIndex}`),
        };
      } else {
        return item;
      }
    });
  }

  public get isMobile(): boolean {
    const ua = window.navigator.userAgent;
    const isAndroid = /(?:Android)/.test(ua);
    // const isFireFox = /(?:Firefox)/.test(ua);
    // const isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua));
    const isPhone = /(?:iPhone)/.test(ua);
    return isAndroid || isPhone;
  }
}
